import React from 'react';
import PropTypes from 'prop-types';

import {
  GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH,
  GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT,
  GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH,
  GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT
} from 'bento-ordering/base/constants/defaultMapProps';
import { sanitizeUrl } from 'bento-ordering/utils/images';

/*
  This component renders the Google maps static image thumbnail.
  It renders a different static url based on the size of the screen to ensure
  that both the resolution and aspect ratio is preserved.

  The three breakpoints are:
    Mobile - < 600px
    Tablet - > 600px and < 960px
    Desktop - > 960px
*/

const StaticMapComponent = props => {
  const { staticUrls, isMediumAndUp, isSmallAndUp, name } = props;

  // find the static url associated with the latitude and longitude
  const mapData = staticUrls;

  const responsiveWidth = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH;

  const responsiveHeight = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT;

  let url;

  if (isMediumAndUp) {
    url = mapData.static_url_desktop;
  } else if (isSmallAndUp) {
    url = mapData.static_url_tablet;
  } else {
    url = mapData.static_url_mobile;
  }

  url = sanitizeUrl(url);

  return (
    <img
      src={url}
      width={responsiveWidth}
      height={responsiveHeight}
      alt={name}
    />
  );
};

StaticMapComponent.propTypes = {
  staticUrls: PropTypes.object.isRequired,
  isMediumAndUp: PropTypes.bool.isRequired,
  isSmallAndUp: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired
};

StaticMapComponent.defaultProps = {
  loadingElement: <div />
};

export default StaticMapComponent;
